module.exports = __webpack_public_path__ + "static/media/complexBanner.6eb4cd79.png";